function clearPendingProductSections() {
  document.querySelectorAll('.missence-pdp-section.is-pending').forEach((section) => {
    section.classList.remove('is-pending');
  });
}

function setMissenceAccordionState(details, isOpen) {
  const content = details.querySelector('.accordion__content');
  const item = details.closest('.missence-pdp-detail-accordions__item');
  if (!content) return;

  details.classList.remove('is-expanding', 'is-collapsing');
  details.dataset.missenceAccordionAnimating = 'false';
  item?.classList.toggle('is-open', isOpen);
  item?.classList.remove('is-expanding', 'is-collapsing');

  if (details.__missenceAccordionEndHandler) {
    content.removeEventListener('transitionend', details.__missenceAccordionEndHandler);
    details.__missenceAccordionEndHandler = null;
  }

  if (isOpen) {
    details.setAttribute('open', '');
    content.style.height = 'auto';
    return;
  }

  details.removeAttribute('open');
  content.style.height = '0px';
}

function syncExclusiveAccordionGroup(group, activeDetails = null) {
  if (!group || group.getAttribute('data-missence-exclusive-accordions') !== 'true') return;

  const detailsElements = Array.from(group.querySelectorAll('.missence-pdp-detail-accordions__item details'));
  if (!detailsElements.length) return;

  let resolvedActiveDetails = activeDetails;

  if (!resolvedActiveDetails || !resolvedActiveDetails.hasAttribute('open')) {
    resolvedActiveDetails = detailsElements.find((details) => details.hasAttribute('open')) || null;
  }

  if (!resolvedActiveDetails) return;

  detailsElements.forEach((details) => {
    if (details !== resolvedActiveDetails) {
      setMissenceAccordionState(details, false);
    }
  });
}

function animateMissenceAccordion(details, shouldOpen) {
  const content = details.querySelector('.accordion__content');
  const item = details.closest('.missence-pdp-detail-accordions__item');
  if (!content) return;

  const isCurrentlyOpen = details.hasAttribute('open') && !details.classList.contains('is-collapsing');
  if (shouldOpen === isCurrentlyOpen && details.dataset.missenceAccordionAnimating !== 'true') return;

  if (details.__missenceAccordionEndHandler) {
    content.removeEventListener('transitionend', details.__missenceAccordionEndHandler);
    details.__missenceAccordionEndHandler = null;
  }

  const startHeight = content.getBoundingClientRect().height;
  content.style.height = `${startHeight}px`;
  details.dataset.missenceAccordionAnimating = 'true';

  if (shouldOpen) {
    details.setAttribute('open', '');
    details.classList.remove('is-collapsing');
    details.classList.add('is-expanding');
    item?.classList.remove('is-collapsing');
    item?.classList.add('is-expanding', 'is-open');
  } else {
    details.classList.remove('is-expanding');
    details.classList.add('is-collapsing');
    item?.classList.remove('is-expanding');
    item?.classList.add('is-collapsing');
  }

  const endHandler = (event) => {
    if (event.target !== content || event.propertyName !== 'height') return;

    content.removeEventListener('transitionend', endHandler);
    details.__missenceAccordionEndHandler = null;
    details.classList.remove('is-expanding', 'is-collapsing');
    item?.classList.remove('is-expanding', 'is-collapsing');
    details.dataset.missenceAccordionAnimating = 'false';

    if (shouldOpen) {
      details.setAttribute('open', '');
      content.style.height = 'auto';
      item?.classList.add('is-open');
      return;
    }

    details.removeAttribute('open');
    content.style.height = '0px';
    item?.classList.remove('is-open');
  };

  details.__missenceAccordionEndHandler = endHandler;
  content.addEventListener('transitionend', endHandler);

  requestAnimationFrame(() => {
    if (shouldOpen) {
      content.style.height = `${content.scrollHeight}px`;
      return;
    }

    content.style.height = '0px';
  });
}

function initMissenceAccordionGroups(scope = document) {
  scope.querySelectorAll('[data-missence-accordion-group]').forEach((group) => {
    group.querySelectorAll('.missence-pdp-detail-accordions__item details').forEach((details) => {
      if (details.dataset.missenceAccordionReady === 'true') return;

      setMissenceAccordionState(details, details.hasAttribute('open'));
      details.dataset.missenceAccordionReady = 'true';

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        const isExclusive = group.getAttribute('data-missence-exclusive-accordions') === 'true';
        const shouldOpen = !details.hasAttribute('open') || details.classList.contains('is-collapsing');

        if (shouldOpen && isExclusive) {
          group.querySelectorAll('.missence-pdp-detail-accordions__item details').forEach((otherDetails) => {
            if (otherDetails !== details) {
              animateMissenceAccordion(otherDetails, false);
            }
          });
        }

        animateMissenceAccordion(details, shouldOpen);
      });
    });
  });

  scope.querySelectorAll('[data-missence-accordion-group][data-missence-exclusive-accordions="true"]').forEach((group) => {
    syncExclusiveAccordionGroup(group);
  });
}

function setIngredientModalPanel(modal, panelId) {
  modal.querySelectorAll('[data-missence-ingredient-panel]').forEach((panel) => {
    const isActive = panel.getAttribute('data-missence-ingredient-panel') === panelId;
    panel.hidden = !isActive;
  });
}

function openIngredientModal(root, panelId) {
  const modal = root.querySelector('[data-missence-ingredient-modal]');
  if (!modal) return;

  setIngredientModalPanel(modal, panelId);
  modal.classList.remove('is-closing');
  modal.classList.remove('is-active');
  modal.hidden = false;
  document.body.classList.add('overflow-hidden');
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      modal.classList.add('is-active');
    });
  });
}

function closeIngredientModal(modal) {
  if (!modal) return;
  modal.classList.remove('is-active');
  modal.classList.add('is-closing');

  const finishClose = () => {
    modal.hidden = true;
    modal.classList.remove('is-closing');
    document.body.classList.remove('overflow-hidden');
  };

  const dialog = modal.querySelector('.missence-pdp-ingredient-modal__dialog');
  if (!dialog) {
    finishClose();
    return;
  }

  dialog.addEventListener('transitionend', finishClose, { once: true });
}

function syncDifferences(root, nextIndex) {
  const track = root.querySelector('[data-missence-differences-track]');
  const pages = Array.from(root.querySelectorAll('[data-missence-differences-page]'));
  const progress = root.querySelector('[data-missence-differences-progress]');
  const prev = root.querySelector('[data-missence-differences-prev]');
  const next = root.querySelector('[data-missence-differences-next]');
  if (!track || !pages.length) return;

  const maxIndex = pages.length - 1;
  const index = Math.max(0, Math.min(nextIndex, maxIndex));

  track.style.transform = `translateX(-${index * 100}%)`;
  root.setAttribute('data-missence-differences-current', String(index));

  pages.forEach((page, pageIndex) => {
    page.classList.toggle('is-active', pageIndex === index);
  });

  if (progress) {
    const visualSteps = pages.length;
    progress.style.width = `${((index + 1) / visualSteps) * 100}%`;
  }

  if (prev) prev.classList.toggle('is-disabled', index === 0);
  if (next) next.classList.toggle('is-disabled', index === maxIndex);
}

function setMissenceGalleryActiveState(root, mediaId) {
  if (!root) return;

  const targetId = String(mediaId);

  root.querySelectorAll('[data-missence-stage]').forEach((stage) => {
    stage.classList.toggle('is-active', stage.getAttribute('data-missence-stage') === targetId);
  });
}

function syncMissenceGalleryNav(root, embla) {
  if (!root || !embla) return;

  const prev = root.querySelector('[data-missence-gallery-prev]');
  const next = root.querySelector('[data-missence-gallery-next]');

  if (prev) prev.classList.toggle('is-disabled', !embla.canScrollPrev());
  if (next) next.classList.toggle('is-disabled', !embla.canScrollNext());
}

function initMissenceProductGallery(root) {
  if (!root || root.dataset.missenceGalleryReady === 'true') return;

  const viewport = root.querySelector('[data-embla-viewport]');
  const zoomButton = root.querySelector('[data-missence-gallery-zoom]');
  if (!viewport) return;
  const slides = Array.from(root.querySelectorAll('[data-missence-slide]'));
  if (!slides.length) return;

  if (zoomButton) {
    zoomButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openMissenceGalleryModal(zoomButton);
    });
  }

  root.dataset.missenceGalleryReady = 'true';

  const initialActiveSlide =
    root.querySelector('.missence-pdp-main__slide.is-active') ||
    slides[0];

  const startIndex = Math.max(0, slides.indexOf(initialActiveSlide));
  let initAttempts = 0;

  const mountEmbla = () => {
    if (root.__missenceEmbla || root.dataset.missenceGalleryReady === 'done') return;

    if (!window.EmblaCarousel) {
      initAttempts += 1;
      if (initAttempts <= 20) {
        window.setTimeout(mountEmbla, 120);
      }
      return;
    }

    const embla = window.EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
      loop: false,
      skipSnaps: false,
      watchDrag: true,
      startIndex,
    });

    const syncSelectedSlide = () => {
      const selectedIndex = embla.selectedScrollSnap();
      const activeSlide = slides[selectedIndex];
      if (!activeSlide) return;
      setMissenceGalleryActiveState(root, activeSlide.getAttribute('data-missence-stage'));
      syncMissenceGalleryNav(root, embla);
    };

    root.__missenceScrollToMedia = (mediaId) => {
      const targetIndex = slides.findIndex((slide) => slide.getAttribute('data-missence-stage') === String(mediaId));
      if (targetIndex === -1) return;
      embla.scrollTo(targetIndex);
    };

    embla.on('init', syncSelectedSlide);
    embla.on('reInit', syncSelectedSlide);
    embla.on('select', syncSelectedSlide);
    root.__missenceEmbla = embla;
    root.dataset.missenceGalleryReady = 'done';
    syncSelectedSlide();
  };

  mountEmbla();

}

function clearMissenceGalleryModalZoom(slide) {
  if (!slide) return;

  slide.classList.remove('is-zoomed');
  const image = slide.querySelector('.missence-pdp-gallery-modal__image');
  if (image) image.style.transformOrigin = '';
}

function setMissenceGalleryModalSlide(modal, mediaId) {
  if (!modal) return;

  const slides = Array.from(modal.querySelectorAll('[data-missence-gallery-modal-slide]'));
  if (!slides.length) return;

  const requestedId = mediaId != null ? String(mediaId) : '';
  const nextSlide = slides.find((slide) => slide.getAttribute('data-missence-gallery-modal-slide') === requestedId) || slides[0];
  const nextId = nextSlide.getAttribute('data-missence-gallery-modal-slide');
  const nextIndex = slides.indexOf(nextSlide);
  const track = modal.querySelector('[data-missence-gallery-modal-track]');

  if (track) {
    track.style.transform = `translateX(-${nextIndex * 100}%)`;
  }

  slides.forEach((slide) => {
    const isActive = slide === nextSlide;
    slide.classList.toggle('is-active', isActive);
    clearMissenceGalleryModalZoom(slide);
  });

  const prev = modal.querySelector('[data-missence-gallery-modal-prev]');
  const next = modal.querySelector('[data-missence-gallery-modal-next]');
  const maxIndex = slides.length - 1;
  if (prev) prev.classList.toggle('is-disabled', nextIndex === 0);
  if (next) next.classList.toggle('is-disabled', nextIndex === maxIndex);

  modal.dataset.missenceGalleryModalActive = nextId || '';
}

function moveMissenceGalleryModalSlide(modal, direction) {
  if (!modal) return;

  const slides = Array.from(modal.querySelectorAll('[data-missence-gallery-modal-slide]'));
  if (!slides.length) return;

  const currentId = modal.dataset.missenceGalleryModalActive;
  const currentIndex = Math.max(0, slides.findIndex((slide) => slide.getAttribute('data-missence-gallery-modal-slide') === currentId));
  const nextIndex = Math.max(0, Math.min(currentIndex + direction, slides.length - 1));
  setMissenceGalleryModalSlide(modal, slides[nextIndex].getAttribute('data-missence-gallery-modal-slide'));
}

function updateMissenceGalleryModalZoom(event) {
  const slide = event.target.closest('[data-missence-gallery-modal-slide]');
  if (!slide?.classList.contains('is-zoomed')) return;

  const image = slide.querySelector('.missence-pdp-gallery-modal__image');
  if (!image) return;

  const rect = slide.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
  const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
  image.style.transformOrigin = `${x}% ${y}%`;
}

function openMissenceGalleryModal(trigger) {
  const productInfo = trigger?.closest('product-info');
  const root = trigger?.closest('[data-missence-gallery]') || productInfo?.querySelector('[data-missence-gallery]');
  if (!root) return;

  const modal = productInfo?.querySelector('[data-missence-gallery-modal]') || root.closest('product-info')?.querySelector('[data-missence-gallery-modal]');
  const activeStage = root.querySelector('.missence-pdp-main__slide.is-active') || root.querySelector('[data-missence-stage]');
  if (!modal || !activeStage) return;

  setMissenceGalleryModalSlide(modal, activeStage.getAttribute('data-missence-stage'));
  modal.classList.remove('is-closing');
  modal.classList.remove('is-active');
  modal.hidden = false;
  document.body.classList.add('overflow-hidden');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      modal.classList.add('is-active');
    });
  });
}

window.missenceOpenProductZoom = (trigger, event) => {
  event?.preventDefault();
  event?.stopPropagation();
  event?.stopImmediatePropagation?.();
  openMissenceGalleryModal(trigger);
};

function closeMissenceGalleryModal(modal) {
  if (!modal) return;
  modal.classList.remove('is-active');
  modal.classList.add('is-closing');

  const finishClose = () => {
    modal.hidden = true;
    modal.classList.remove('is-closing');
    modal.querySelectorAll('[data-missence-gallery-modal-slide]').forEach((slide) => {
      clearMissenceGalleryModalZoom(slide);
    });
    document.body.classList.remove('overflow-hidden');
  };

  const dialog = modal.querySelector('.missence-pdp-gallery-modal__dialog');
  if (!dialog) {
    finishClose();
    return;
  }

  dialog.addEventListener('transitionend', finishClose, { once: true });
}

function syncMissenceSubscriptionCards(root) {
  if (!root) return;

  root.querySelectorAll('[data-missence-subscription-card]').forEach((card) => {
    const radio = card.querySelector('.missence-pdp-main__subscription-radio');
    card.classList.toggle('is-selected', Boolean(radio?.checked));
  });
}

function dispatchMissenceInputChange(input) {
  if (!input) return;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function syncMissenceShopifyAppBlock(root) {
  if (!root) return;

  const productInfo = root.closest('product-info');
  const currentVariantId = productInfo?.querySelector('input.product-variant-id')?.value || '';
  const subscriptionVariantId = root.getAttribute('data-missence-subscription-variant-id') || currentVariantId;
  const checkedOption = root.querySelector('.missence-pdp-main__subscription-radio:checked');
  if (!checkedOption) return;

  const purchaseType = checkedOption.dataset.sellingPlanType || 'subscription';
  const sellingPlanId = checkedOption.value || '';
  const targetVariantId = purchaseType === 'subscription' ? subscriptionVariantId : currentVariantId;
  if (!targetVariantId) return;

  document.querySelectorAll('.shopify_subscriptions_app_block_container').forEach((container) => {
    const targetSection = container.querySelector(`.shopify_subscriptions_app_block[data-variant-id="${targetVariantId}"]`);
    if (!targetSection) return;

    const oneTimeInput = targetSection.querySelector('input[data-radio-type="one_time_purchase"]');
    const sellingPlanGroupInput = targetSection.querySelector('input[data-radio-type="selling_plan_group"]');
    const sellingPlanInput = sellingPlanId
      ? targetSection.querySelector(`input[data-radio-type="selling_plan"][data-selling-plan-id="${sellingPlanId}"]`)
      : null;
    const hiddenInput = container.querySelector('input.selected-selling-plan-id');

    if (purchaseType === 'one-time' || sellingPlanId === '') {
      if (oneTimeInput) {
        oneTimeInput.checked = true;
        dispatchMissenceInputChange(oneTimeInput);
      }

      if (hiddenInput) {
        hiddenInput.value = '';
        dispatchMissenceInputChange(hiddenInput);
      }

      return;
    }

    if (sellingPlanGroupInput) {
      sellingPlanGroupInput.checked = true;
      dispatchMissenceInputChange(sellingPlanGroupInput);
    }

    if (sellingPlanInput) {
      sellingPlanInput.checked = true;
      dispatchMissenceInputChange(sellingPlanInput);
    }

    if (hiddenInput) {
      hiddenInput.value = sellingPlanId;
      dispatchMissenceInputChange(hiddenInput);
    }
  });
}

function syncMissenceSellingPlan(root) {
  if (!root) return;

  const form = root.closest('form');
  const hiddenInput =
    root.querySelector('[data-missence-selling-plan]') ||
    form?.querySelector('[data-missence-selling-plan]') ||
    root.closest('product-info')?.querySelector('[data-missence-selling-plan]');
  const checkedOption = root.querySelector('.missence-pdp-main__subscription-radio:checked');
  if (!checkedOption) return;

  const sellingPlanId = checkedOption.getAttribute('value') || '';
  const type = checkedOption.dataset.sellingPlanType || 'subscription';

  if (hiddenInput) {
    hiddenInput.value = sellingPlanId;
    hiddenInput.disabled = type === 'one-time' || sellingPlanId === '';
  }

  syncMissenceSubscriptionCards(root);
  syncMissenceLeadText(root, type);
  syncMissenceHeaderPrice(root, type);
  syncMissenceShopifyAppBlock(root);
}

function syncMissenceLeadText(root, purchaseMode = null) {
  if (!root) return;

  const productInfo = root.closest('product-info');
  const leadText = productInfo?.querySelector('[data-missence-lead-text]');
  const description = productInfo?.querySelector('[data-missence-description]');
  const bodyText = description?.querySelector('.missence-pdp-copy-md');
  const hasCustomSubscriptionUi = root.hasAttribute('data-missence-subscription-variant-id');
  if (!description) return;

  const mode =
    purchaseMode ||
    root.querySelector('.missence-pdp-main__subscription-radio:checked')?.dataset.sellingPlanType ||
    'subscription';

  const shouldHideLeadText =
    hasCustomSubscriptionUi || (leadText?.dataset.hideOnSubscription === 'true' && mode === 'subscription');

  if (leadText) {
    leadText.hidden = shouldHideLeadText;
  }

  description.classList.toggle('is-lead-hidden', shouldHideLeadText);

  if (hasCustomSubscriptionUi) {
    description.hidden = true;
    return;
  }

  const hasVisibleBodyText = Boolean(bodyText && !bodyText.hidden && bodyText.textContent.trim() !== '');
  description.hidden = shouldHideLeadText && !hasVisibleBodyText;
}

function syncMissenceHeaderPrice(root, purchaseMode = null) {
  if (!root) return;

  const productInfo = root.closest('product-info');
  const mainPrice = productInfo?.querySelector('[data-missence-main-price]');
  if (!mainPrice) return;
  const hasCustomSubscriptionUi = root.hasAttribute('data-missence-subscription-variant-id');

  const mode =
    purchaseMode ||
    root.querySelector('.missence-pdp-main__subscription-radio:checked')?.dataset.sellingPlanType ||
    'subscription';

  mainPrice.hidden = hasCustomSubscriptionUi || mode === 'subscription';
  syncMissenceVisibilityContainer(productInfo?.querySelector('[data-missence-price-group]'));
}

function syncMissenceVisibilityContainer(container) {
  if (!container) return;

  const hasVisibleContent = Array.from(container.children).some((child) => {
    if (child.hidden) return false;
    if (window.getComputedStyle(child).display === 'none') return false;
    return child.textContent.trim() !== '';
  });

  container.hidden = !hasVisibleContent;
}

function parseMissenceJsonScript(node) {
  if (!node) return null;

  try {
    return JSON.parse(node.textContent || '');
  } catch (error) {
    return null;
  }
}

function renderMissenceTemplate(template, values) {
  if (typeof template !== 'string' || template === '') return '';

  return template
    .replaceAll('{discount}', values.discount || '')
    .replaceAll('{savings_percent}', values.savingsPercent || '')
    .replaceAll('{days}', values.days || '')
    .replaceAll('{weeks}', values.weeks || '')
    .replaceAll('{monthly_price}', values.monthlyPrice || '')
    .replaceAll('{daily_price}', values.dailyPrice || '')
    .replaceAll('{per_dose_price}', values.dosePrice || '')
    .replaceAll('{dose_price}', values.dosePrice || '')
    .replaceAll('{total_price}', values.totalPrice || '')
    .replaceAll('{plan_name}', values.planName || '')
    .replaceAll('{billing_frequency}', values.billingFrequency || '');
}

function splitMissenceBenefits(value) {
  if (typeof value !== 'string' || value.trim() === '') return [];

  return value
    .replaceAll('<br />', ',')
    .replaceAll('<br/>', ',')
    .replaceAll('<br>', ',')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

function syncMissenceSubscriptionCopy(root) {
  if (!root) return;

  const oneTimeVariants = parseMissenceJsonScript(root.querySelector('[data-missence-one-time-variants-json]')) || [];

  root.querySelectorAll('[data-missence-subscription-card]').forEach((card) => {
    const cardData = parseMissenceJsonScript(card.querySelector('[data-missence-subscription-card-json]'));
    if (!cardData) return;

    const matchingOneTimeVariant = oneTimeVariants.find((variant) => Number(variant.days) === Number(cardData.days));
    const fallbackOneTimeVariant = oneTimeVariants.find((variant) => Number(variant.price) > 0) || null;
    const referencePrice = Number(matchingOneTimeVariant?.price || fallbackOneTimeVariant?.price || 0);
    const referenceDays = Number(matchingOneTimeVariant?.days || fallbackOneTimeVariant?.days || 30) || 30;
    const allocationPrice = Number(cardData.allocationPrice || 0);
    const allocationDays = Number(cardData.days || 0);
    const compareMonthlyPrice = referenceDays > 0 ? (referencePrice * 30) / referenceDays : referencePrice;
    const allocationMonthlyPrice = allocationDays > 0 ? (allocationPrice * 30) / allocationDays : allocationPrice;
    const savingsPercent =
      compareMonthlyPrice > allocationMonthlyPrice && compareMonthlyPrice > 0
        ? Math.round(((compareMonthlyPrice - allocationMonthlyPrice) * 100) / compareMonthlyPrice)
        : 0;

    const templateValues = {
      discount: `${savingsPercent}%`,
      savingsPercent: String(savingsPercent),
      days: String(cardData.daysLabel || ''),
      weeks: String(cardData.weeksLabel || ''),
      monthlyPrice: String(cardData.monthlyPrice || ''),
      dailyPrice: String(cardData.dailyPrice || ''),
      dosePrice: String(cardData.dosePrice || ''),
      totalPrice: String(cardData.totalPrice || ''),
      planName: String(cardData.planName || ''),
      billingFrequency: String(cardData.billingFrequency || ''),
    };

    const title = card.querySelector('[data-missence-subscription-title]');
    const badge = card.querySelector('[data-missence-subscription-badge]');
    const price = card.querySelector('[data-missence-subscription-price]');
    const metaLeft = card.querySelector('[data-missence-subscription-meta-left]');
    const metaRight = card.querySelector('[data-missence-subscription-meta-right]');
    const benefits = card.querySelector('[data-missence-subscription-benefits]');

    if (title) title.textContent = renderMissenceTemplate(cardData.titleTemplate, templateValues);
    if (price) price.textContent = renderMissenceTemplate(cardData.priceTemplate, templateValues);
    if (metaLeft) metaLeft.textContent = renderMissenceTemplate(cardData.metaLeftTemplate, templateValues);
    if (metaRight) metaRight.textContent = renderMissenceTemplate(cardData.metaRightTemplate, templateValues);

    if (badge) {
      if (savingsPercent > 0) {
        badge.hidden = false;
        badge.textContent = renderMissenceTemplate(cardData.badgeTemplate, templateValues);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    }

    if (benefits) {
      const benefitItems = splitMissenceBenefits(renderMissenceTemplate(cardData.benefitsTemplate, templateValues));
      benefits.innerHTML = '';

      benefitItems.forEach((item) => {
        const span = document.createElement('span');
        span.textContent = item;
        benefits.appendChild(span);
      });
    }
  });
}

function syncMissenceTabState(root, activeTabKey, activeVariantId = '') {
  if (!root) return;

  root.querySelectorAll('[data-missence-subscription-tab-trigger]').forEach((trigger) => {
    const isActive = activeTabKey !== 'variant' && trigger.getAttribute('data-missence-subscription-tab-trigger') === activeTabKey;
    trigger.classList.toggle('is-active', isActive);
    trigger.setAttribute('aria-selected', String(isActive));
  });

  root.querySelectorAll('[data-missence-variant-tab-trigger]').forEach((trigger) => {
    const isActive =
      activeTabKey === 'variant' && trigger.getAttribute('data-missence-variant-tab-trigger') === String(activeVariantId);
    trigger.classList.toggle('is-active', isActive);
    trigger.setAttribute('aria-pressed', String(isActive));
  });
}

function syncMissencePurchaseBlock(productInfo, sourceHtml) {
  if (!productInfo || !sourceHtml) return;

  const liveRoot = productInfo.querySelector('[data-missence-subscription-root]');
  const nextRoot = sourceHtml.querySelector('[data-missence-subscription-root]');

  if (!liveRoot || !nextRoot) return;

  const activeSubscriptionTrigger = liveRoot.querySelector('[data-missence-subscription-tab-trigger].is-active');
  const activeVariantTrigger = liveRoot.querySelector('[data-missence-variant-tab-trigger].is-active');
  const activeTabKey = activeVariantTrigger
    ? 'variant'
    : activeSubscriptionTrigger?.getAttribute('data-missence-subscription-tab-trigger') || 'subscription';
  const activeVariantId = activeVariantTrigger?.getAttribute('data-missence-variant-tab-trigger') || '';

  liveRoot.innerHTML = nextRoot.innerHTML;
  delete liveRoot.dataset.missenceSubscriptionsReady;
  initMissenceSubscriptions(liveRoot);

  if (activeTabKey === 'variant' && activeVariantId !== '') {
    syncMissenceTabState(liveRoot, 'variant', activeVariantId);
    setMissenceSubscriptionPanelState(liveRoot, 'one-time');
    return;
  }

  activateMissenceSubscriptionTab(liveRoot, activeTabKey);
}

function setMissenceSubscriptionPanelState(root, tabKey) {
  root.querySelectorAll('[data-missence-subscription-tab-panel]').forEach((panel) => {
    const isActive = panel.getAttribute('data-missence-subscription-tab-panel') === tabKey;
    panel.classList.toggle('is-active', isActive);
    panel.hidden = !isActive;
  });

  const targetPanel = root.querySelector(`[data-missence-subscription-tab-panel="${tabKey}"]`);
  const firstRadio = targetPanel?.querySelector('.missence-pdp-main__subscription-radio');
  if (firstRadio) firstRadio.checked = true;
  syncMissenceSellingPlan(root);
}

function activateMissenceSubscriptionTab(root, tabKey) {
  if (!root) return;

  if (tabKey === 'subscription') {
    const subscriptionVariantId = root.getAttribute('data-missence-subscription-variant-id');
    const productInfo = root.closest('product-info');
    const selectedVariantId = productInfo?.querySelector('input.product-variant-id')?.value;

    if (
      subscriptionVariantId &&
      productInfo &&
      selectedVariantId &&
      String(selectedVariantId) !== String(subscriptionVariantId)
    ) {
      syncMissenceTabState(root, tabKey);
      setMissenceSubscriptionPanelState(root, tabKey);
      selectMissenceVariant(productInfo, subscriptionVariantId);
      return;
    }
  }

  syncMissenceTabState(root, tabKey);
  setMissenceSubscriptionPanelState(root, tabKey);
}

function initMissenceSubscriptions(root) {
  if (!root || root.dataset.missenceSubscriptionsReady === 'true') return;
  root.dataset.missenceSubscriptionsReady = 'true';
  syncMissenceSubscriptionCopy(root);
  syncMissenceSellingPlan(root);
}

function selectMissenceVariant(productInfo, variantId) {
  if (!variantId) return;

  const variantSelects = productInfo?.querySelector('variant-selects');
  if (!variantSelects) return null;
  const targetVariantData = productInfo?.querySelector(`[data-missence-variant-tab-json="${variantId}"]`)?.textContent;
  const targetVariant = targetVariantData ? JSON.parse(targetVariantData) : null;
  if (!targetVariant) return null;

  const optionValues = targetVariant.options || [];
  const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
  const nextInputs = [];

  fieldsets.forEach((fieldset, index) => {
    const optionValue = optionValues[index];
    if (typeof optionValue !== 'string') return;
    const nextInput = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === optionValue);
    if (nextInput) {
      nextInput.checked = true;
      nextInputs.push(nextInput);
    }
  });

  const lastInput = nextInputs[nextInputs.length - 1];
  if (lastInput) {
    lastInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  return { targetVariant, lastInput };
}

function activateMissenceVariantTab(trigger) {
  const variantId = trigger?.getAttribute('data-missence-variant-tab-trigger');
  if (!variantId) return;

  const root = trigger.closest('[data-missence-subscription-root]');
  const productInfo = trigger.closest('product-info');
  if (root) {
    syncMissenceTabState(root, 'variant', variantId);
    setMissenceSubscriptionPanelState(root, 'one-time');
  }
  selectMissenceVariant(productInfo, variantId);
}

let pendingMissenceCartUpsell = null;
let pendingMissenceCartUpsellSawDrawer = false;
const MISSENCE_CART_UPSELL_ANIMATION_MS = 380;

function initMissenceCartUpsells(scope = document) {
  scope.querySelectorAll('[data-missence-cart-upsell]').forEach((popup) => {
    popup.hidden = true;
    popup.classList.remove('is-active', 'is-closing', 'is-loading');
  });
}

function isMissenceCartDrawerOpen() {
  const drawer = document.querySelector('cart-drawer');
  return Boolean(drawer?.classList.contains('active') || document.body.classList.contains('cart-drawer-open'));
}

function queueMissenceCartUpsell(popup) {
  if (!popup) return;

  const suppressCartDrawer = popup.getAttribute('data-suppress-cart-drawer') === 'true';
  if (suppressCartDrawer) {
    window.__missenceSuppressNextCartDrawer = true;
  }

  pendingMissenceCartUpsell = popup;
  pendingMissenceCartUpsellSawDrawer = isMissenceCartDrawerOpen();
  hideMissenceCartUpsell(popup);

  if (suppressCartDrawer) {
    window.setTimeout(() => {
      if (!pendingMissenceCartUpsell || pendingMissenceCartUpsell !== popup || isMissenceCartDrawerOpen()) return;

      pendingMissenceCartUpsell = null;
      showMissenceCartUpsell(popup);
    }, 260);
    return;
  }

  window.setTimeout(() => {
    if (!pendingMissenceCartUpsell || pendingMissenceCartUpsell !== popup) return;
    if (pendingMissenceCartUpsellSawDrawer || isMissenceCartDrawerOpen()) return;

    pendingMissenceCartUpsell = null;
    showMissenceCartUpsell(popup);
  }, 900);
}

function showMissenceCartUpsell(popup) {
  if (!popup) return;

  document.querySelectorAll('[data-missence-cart-upsell].is-active').forEach((activePopup) => {
    if (activePopup !== popup) hideMissenceCartUpsell(activePopup);
  });

  if (popup.__missenceHideTimer) {
    window.clearTimeout(popup.__missenceHideTimer);
    popup.__missenceHideTimer = null;
  }

  popup.hidden = false;
  popup.classList.remove('is-active', 'is-closing', 'is-loading');
  popup.getBoundingClientRect();

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      popup.classList.add('is-active');
    });
  });
}

function hideMissenceCartUpsell(popup) {
  if (!popup) return;

  if (popup.hidden) return;

  if (popup.__missenceHideTimer) {
    window.clearTimeout(popup.__missenceHideTimer);
    popup.__missenceHideTimer = null;
  }

  const finishClose = () => {
    if (popup.classList.contains('is-active')) return;
    popup.hidden = true;
    popup.classList.remove('is-closing', 'is-loading');
    popup.removeEventListener('transitionend', handleTransitionEnd);
    if (popup.__missenceHideTimer) {
      window.clearTimeout(popup.__missenceHideTimer);
      popup.__missenceHideTimer = null;
    }
  };

  const handleTransitionEnd = (event) => {
    if (event.target !== popup || event.propertyName !== 'transform') return;
    finishClose();
  };

  popup.addEventListener('transitionend', handleTransitionEnd);
  popup.classList.add('is-closing');
  popup.classList.remove('is-active', 'is-loading');
  popup.__missenceHideTimer = window.setTimeout(finishClose, MISSENCE_CART_UPSELL_ANIMATION_MS);
}

function addMissenceCartUpsell(button) {
  const popup = button?.closest('[data-missence-cart-upsell]');
  const variantId = popup?.getAttribute('data-variant-id');
  if (!popup || !variantId || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

  popup.classList.add('is-loading');
  button.setAttribute('aria-disabled', 'true');

  if (window.MissenceCart && typeof window.MissenceCart.add === 'function') {
    window.MissenceCart.add({
      id: variantId,
      quantity: 1,
      source: 'missence-pdp-cart-upsell',
      triggeredBy: button,
    });
    return;
  }

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(window.routes.cart_add_url, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) throw response;
      hideMissenceCartUpsell(popup);
      if (window.routes?.cart_url) window.location.href = window.routes.cart_url;
    })
    .catch((error) => {
      console.error(error);
      popup.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
    });
}

if (!window.__missenceProductPageBound) {
  window.__missenceProductPageBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-missence-gallery]').forEach(initMissenceProductGallery);
      document.querySelectorAll('[data-missence-subscription-root]').forEach(initMissenceSubscriptions);
      initMissenceCartUpsells();
      initMissenceAccordionGroups();
      requestAnimationFrame(clearPendingProductSections);
    });
  } else {
    document.querySelectorAll('[data-missence-gallery]').forEach(initMissenceProductGallery);
    document.querySelectorAll('[data-missence-subscription-root]').forEach(initMissenceSubscriptions);
    initMissenceCartUpsells();
    initMissenceAccordionGroups();
    requestAnimationFrame(clearPendingProductSections);
  }

  window.addEventListener('load', clearPendingProductSections);

  document.addEventListener('click', (event) => {
  const claimsToggle = event.target.closest('[data-missence-claims-toggle]');

  const upsellClose = event.target.closest('[data-missence-cart-upsell-close]');
  if (upsellClose) {
    hideMissenceCartUpsell(upsellClose.closest('[data-missence-cart-upsell]'));
    return;
  }

  const upsellAdd = event.target.closest('[data-missence-cart-upsell-add]');
  if (upsellAdd) {
    addMissenceCartUpsell(upsellAdd);
    return;
  }

  if (claimsToggle) {
    const dropdown = claimsToggle.closest('[data-missence-claims-dropdown]');
    if (!dropdown) return;

    const menu = dropdown.querySelector('[data-missence-claims-menu]');
    const isOpen = dropdown.classList.toggle('is-open');
    claimsToggle.setAttribute('aria-expanded', String(isOpen));
    if (menu) menu.hidden = !isOpen;
    return;
  }

  const galleryPrev = event.target.closest('[data-missence-gallery-prev]');

  if (galleryPrev && !galleryPrev.classList.contains('is-disabled')) {
    const gallery = galleryPrev.closest('[data-missence-gallery]');
    const embla = gallery?.__missenceEmbla;
    if (!gallery || !embla) return;
    embla.scrollPrev();
    return;
  }

  const galleryNext = event.target.closest('[data-missence-gallery-next]');

  if (galleryNext && !galleryNext.classList.contains('is-disabled')) {
    const gallery = galleryNext.closest('[data-missence-gallery]');
    const embla = gallery?.__missenceEmbla;
    if (!gallery || !embla) return;
    embla.scrollNext();
    return;
  }

  const galleryZoom = event.target.closest('[data-missence-gallery-zoom]');

  if (galleryZoom) {
    openMissenceGalleryModal(galleryZoom);
    return;
  }

  const subscriptionTabTrigger = event.target.closest('[data-missence-subscription-tab-trigger]');

  if (subscriptionTabTrigger) {
    const root = subscriptionTabTrigger.closest('[data-missence-subscription-root]');
    if (!root) return;
    activateMissenceSubscriptionTab(root, subscriptionTabTrigger.getAttribute('data-missence-subscription-tab-trigger'));
    return;
  }

  const variantTabTrigger = event.target.closest('[data-missence-variant-tab-trigger]');

  if (variantTabTrigger) {
    activateMissenceVariantTab(variantTabTrigger);
    return;
  }

  const subscriptionCard = event.target.closest('[data-missence-subscription-card]');

  if (subscriptionCard) {
    const root = subscriptionCard.closest('[data-missence-subscription-root]');
    const radio = subscriptionCard.querySelector('.missence-pdp-main__subscription-radio');
    if (!root || !radio) return;

    event.preventDefault();
    radio.checked = true;
    syncMissenceSellingPlan(root);
    return;
  }

  const galleryClose = event.target.closest('[data-missence-gallery-close]');

  if (galleryClose) {
    closeMissenceGalleryModal(galleryClose.closest('[data-missence-gallery-modal]'));
    return;
  }

  const galleryModalPrev = event.target.closest('[data-missence-gallery-modal-prev]');

  if (galleryModalPrev && !galleryModalPrev.classList.contains('is-disabled')) {
    moveMissenceGalleryModalSlide(galleryModalPrev.closest('[data-missence-gallery-modal]'), -1);
    return;
  }

  const galleryModalNext = event.target.closest('[data-missence-gallery-modal-next]');

  if (galleryModalNext && !galleryModalNext.classList.contains('is-disabled')) {
    moveMissenceGalleryModalSlide(galleryModalNext.closest('[data-missence-gallery-modal]'), 1);
    return;
  }

  const galleryModalSlide = event.target.closest('[data-missence-gallery-modal-slide]');

  if (galleryModalSlide) {
    galleryModalSlide.classList.add('is-zoomed');
    updateMissenceGalleryModalZoom(event);
    return;
  }

  const claimsTrigger = event.target.closest('[data-missence-claims-trigger]');

  if (claimsTrigger) {
    const root = claimsTrigger.closest('[data-missence-claims]');
    if (!root) return;

    const targetId = claimsTrigger.getAttribute('data-missence-claims-trigger');
    syncClaims(root, targetId);

    const dropdown = root.querySelector('[data-missence-claims-dropdown]');
    const menu = root.querySelector('[data-missence-claims-menu]');
    const toggle = root.querySelector('[data-missence-claims-toggle]');
    const nextLabel = claimsTrigger.getAttribute('data-missence-claims-label') || claimsTrigger.textContent.trim();
    root.querySelectorAll('[data-missence-claims-current]').forEach((current) => {
      current.textContent = nextLabel;
    });

    if (dropdown) dropdown.classList.remove('is-open');
    if (menu) menu.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  const comparisonTrigger = event.target.closest('[data-missence-comparison-trigger]');

  if (comparisonTrigger) {
    const root = comparisonTrigger.closest('[data-missence-comparison]');
    if (!root) return;

    const targetId = comparisonTrigger.getAttribute('data-missence-comparison-trigger');
    syncPanels(root, targetId, 'comparison');
  }

  const ingredientTrigger = event.target.closest('[data-missence-ingredient-open]');

  if (ingredientTrigger) {
    const root = ingredientTrigger.closest('[data-missence-ingredients]');
    if (!root) return;

    openIngredientModal(root, ingredientTrigger.getAttribute('data-missence-ingredient-open'));
    return;
  }

  const ingredientClose = event.target.closest('[data-missence-ingredient-close]');

  if (ingredientClose) {
    closeIngredientModal(ingredientClose.closest('[data-missence-ingredient-modal]'));
    return;
  }

  const differencesPrev = event.target.closest('[data-missence-differences-prev]');

  if (differencesPrev && !differencesPrev.classList.contains('is-disabled')) {
    const root = differencesPrev.closest('[data-missence-differences]');
    if (!root) return;
    const current = Number(root.getAttribute('data-missence-differences-current') || 0);
    syncDifferences(root, current - 1);
    return;
  }

  const differencesNext = event.target.closest('[data-missence-differences-next]');

  if (differencesNext && !differencesNext.classList.contains('is-disabled')) {
    const root = differencesNext.closest('[data-missence-differences]');
    if (!root) return;
    const current = Number(root.getAttribute('data-missence-differences-current') || 0);
    syncDifferences(root, current + 1);
    return;
  }

  document.querySelectorAll('[data-missence-claims-dropdown].is-open').forEach((dropdown) => {
    if (!event.target.closest('[data-missence-claims-dropdown]')) {
      dropdown.classList.remove('is-open');
      const menu = dropdown.querySelector('[data-missence-claims-menu]');
      const toggle = dropdown.querySelector('[data-missence-claims-toggle]');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });
  });

  document.addEventListener('change', (event) => {
  const claimsSelect = event.target.closest('[data-missence-claims-select]');
  if (claimsSelect) {
    const root = claimsSelect.closest('[data-missence-claims]');
    if (!root) return;
    syncClaims(root, claimsSelect.value);
  }

  const subscriptionOption = event.target.closest('.missence-pdp-main__subscription-radio');
  if (subscriptionOption) {
    const root = subscriptionOption.closest('[data-missence-subscription-root]');
    if (!root) return;
    syncMissenceSellingPlan(root);
  }
  });

  document.addEventListener('mousemove', (event) => {
  if (!event.target.closest('[data-missence-gallery-modal-slide]')) return;
  updateMissenceGalleryModalZoom(event);
  });

  document.addEventListener('mouseover', (event) => {
  const slide = event.target.closest('[data-missence-gallery-modal-slide]');
  if (!slide) return;
  slide.classList.add('is-zoomed');
  updateMissenceGalleryModalZoom(event);
  });

  document.addEventListener('mouseout', (event) => {
  const slide = event.target.closest('[data-missence-gallery-modal-slide]');
  if (!slide || slide.contains(event.relatedTarget)) return;
  clearMissenceGalleryModalZoom(slide);
  });

  document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-missence-cart-upsell].is-active').forEach((popup) => {
    hideMissenceCartUpsell(popup);
  });
  document.querySelectorAll('[data-missence-gallery-modal]:not([hidden])').forEach((modal) => {
    closeMissenceGalleryModal(modal);
  });
  document.querySelectorAll('[data-missence-ingredient-modal]:not([hidden])').forEach((modal) => {
    closeIngredientModal(modal);
  });
  });

  if (!window.__missenceProductVariantSubscriber && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.__missenceProductVariantSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const sectionId = data?.sectionId;
      const featuredMediaId = data?.variant?.featured_media?.id;
      const productInfo = sectionId ? document.querySelector(`product-info[data-section="${sectionId}"]`) : null;
      if (!productInfo) return;

      syncMissencePurchaseBlock(productInfo, data?.html);

      if (!featuredMediaId) return;

      const root = productInfo.querySelector('[data-missence-gallery]');
      if (!root) return;

      const targetId = String(featuredMediaId);
      if (typeof root.__missenceScrollToMedia === 'function') {
        root.__missenceScrollToMedia(targetId);
      } else {
        setMissenceGalleryActiveState(root, targetId);
      }
    });
  }

  if (!window.__missenceProductCartUpsellSubscriber && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.__missenceProductCartUpsellSubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const detail = event || {};

      if (detail.source === 'product-form') {
        const popup = document.querySelector('[data-missence-cart-upsell]');
        if (popup) queueMissenceCartUpsell(popup);
        return;
      }

      if (detail.source === 'missence-pdp-cart-upsell') {
        document.querySelectorAll('[data-missence-cart-upsell]').forEach((popup) => {
          hideMissenceCartUpsell(popup);
          popup.querySelector('[data-missence-cart-upsell-add]')?.removeAttribute('aria-disabled');
        });
      }
    });
  }

  document.addEventListener('missence:cart:drawer-opened', () => {
    if (pendingMissenceCartUpsell) pendingMissenceCartUpsellSawDrawer = true;
  });

  document.addEventListener('missence:cart:drawer-closed', () => {
    if (!pendingMissenceCartUpsell) return;

    const popup = pendingMissenceCartUpsell;
    pendingMissenceCartUpsell = null;
    window.setTimeout(() => showMissenceCartUpsell(popup), 120);
  });

  document.addEventListener('missence:cart:error', (event) => {
    if (event.detail?.source !== 'missence-pdp-cart-upsell') return;

    document.querySelectorAll('[data-missence-cart-upsell]').forEach((popup) => {
      popup.classList.remove('is-loading');
      popup.querySelector('[data-missence-cart-upsell-add]')?.removeAttribute('aria-disabled');
    });
  });

  document.querySelectorAll('[data-missence-differences]').forEach((root) => {
    syncDifferences(root, Number(root.getAttribute('data-missence-differences-current') || 0));
  });
}


function syncClaims(root, targetId) {
  syncPanels(root, targetId, 'claims');
  root.querySelectorAll('.missence-pdp-claims__menu-item').forEach((item) => {
    const itemTarget = item.getAttribute('data-missence-claims-trigger');
    if (itemTarget) {
      item.classList.toggle('is-active', itemTarget === targetId);
    }
  });
}

function syncPanels(root, targetId, namespace) {
  root.querySelectorAll(`[data-missence-${namespace}-trigger]`).forEach((trigger) => {
    trigger.classList.toggle('is-active', trigger.getAttribute(`data-missence-${namespace}-trigger`) === targetId);
  });

  root.querySelectorAll(`[data-missence-${namespace}-panel]`).forEach((panel) => {
    panel.classList.toggle('is-active', panel.getAttribute(`data-missence-${namespace}-panel`) === targetId);
  });
}
